import 'rc-slider/assets/index.css';
import Slider from 'rc-slider';
import ToolTip from '../common/ToolTip';

const HandleTooltip = (props) => {
  const { value, Dyn, children } = props;
  return (
    <ToolTip tip={`${value}`} follow={true} Dyn={Dyn} dir="t">
        {children}
    </ToolTip>
  );
};

const TooltipSlider = ({
  Dyn,
  ...props
}) => {
  const tipHandleRender = (node, handleProps) => {
    return (
      <HandleTooltip
        value={handleProps.value}
        Dyn={Dyn}
      >
        {node}
      </HandleTooltip>
    );
  };

  return <Slider {...props} handleRender={tipHandleRender} />;
};

export default TooltipSlider;
